import React from 'react';
import { MdArrowDropDown } from 'react-icons/md';

export default function FacilityUnitFAQ({
    data,
}) {
    return (
        <div id="facilityUnitFaq" className="facility-unit__detail-box facility-unit__detail-box--mob-full facility-unit-faq">
            <h2 className="facility-unit__detail-title facility-unit-faq__title">{data.titleText}</h2>
            <div className="facility-unit-faq__questions" id="faq-accordion">
                {data.questions.map((item, index) => (
                    <div key={index} className="facility-unit-faq__item">
                        <button
                            id={`faq-question${index + 1}`}
                            className="facility-unit-faq__question collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target={`#faq-answer${index + 1}`}
                            aria-expanded="false"
                            aria-controls={`faq-answer${index + 1}`}
                        >
                            <span className="facility-unit-faq__question-text">
                                <span>{index + 1}.</span>
                                <span>{item.question}</span>
                            </span>
                            <MdArrowDropDown className="facility-unit-faq__question-icon" />
                        </button>
                        <div
                            id={`faq-answer${index + 1}`}
                            className="facility-unit-faq__answer collapse"
                            data-parent="#faq-accordion"
                        >
                            <div className="facility-unit-faq__answer-content">
                                {item.answers.map((answer, answerIndex) => (
                                    <p key={answerIndex} className="facility-unit-faq__answer-text">
                                        {answer}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
